import React from 'react';

import LskHome from '../Chatapp/lskHome2.js';

export default function Chat() {
  return (
    <LskHome/>
  );
}